import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { CommonsService } from 'src/app/services/commons.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-add-documentation',
  templateUrl: './add-documentation.component.html',
  styleUrls: ['./add-documentation.component.scss']
})
export class AddDocumentationComponent implements OnInit {

  @Input() url: string;
  @Input() isRapidScore: boolean;
  @Input() headerFooter: boolean;
  show: boolean;

  constructor(private cs: CommonsService, private translate: TranslateService) { }

  ngOnInit() {
    this.cs.firstChargePage('Engagement', 'KO - se necesita mas documentacion', 'funnel');
    this.cs.eventsAnalitics('visit screen', 'KO - se necesita mas documentacion', 'engagement');
    const v = JSON.parse(sessionStorage.getItem('getParams'));
    if (v) {
      this.show = v[0] === '3';
    }

    // Establecer el idioma basado en sessionStorage
    const language = sessionStorage.getItem('language') || 'es_ES';
    this.translate.setDefaultLang(language);
    this.translate.use(language);
    document.documentElement.lang = language.substring(0, 2);
  }

  close() {
    if (this.url && this.url.includes('http')) {
      sessionStorage.removeItem('auxParam');
      sessionStorage.removeItem('getParams');
      sessionStorage.removeItem('_k_engagement');
      sessionStorage.removeItem('Channel');
      window.location.href = this.url;
    }
  }
}
